import React, { useEffect, useState } from 'react';
import { Typography, Link, Stack } from '@mui/material';
import { getFileSize, formatFileSize } from '../../../Shared/FileSize/getFileSize.ts';

interface MessageProps {
  message: any;
}

const MessageFile: React.FC<MessageProps> = ({ message }) => {
  const [displaySize, setDisplaySize] = useState<string>('...');

  const fileUrl =
    message?.content?.url ||
    message?.content?.media?.s3_object?.url ||
    message?.content?.media?.url;

  const bodyText = message?.content?.body?.text || '';
  const fileName = message?.content?.filename || 'Document';
  const fallbackSize = message?.content?.file_size;

  useEffect(() => {
    if (fileUrl) {
      getFileSize(fileUrl).then((bytes) => {
        if (bytes !== null) {
          setDisplaySize(formatFileSize(bytes));
        } else if (fallbackSize) {
          setDisplaySize(formatFileSize(fallbackSize));
        } else {
          setDisplaySize('Unknown size');
        }
      });
    } else if (fallbackSize) {
      setDisplaySize(formatFileSize(fallbackSize));
    } else {
      setDisplaySize('Unknown size');
    }
  }, [fileUrl, fallbackSize]);

  try {
    return (
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography
            variant="body1"
            fontWeight="bold"
            sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
          >
            📄 {fileName}
          </Typography>
          {fileUrl && (
            <Link href={fileUrl} target="_blank" rel="noopener noreferrer">
              ⬇️
            </Link>
          )}
        </Stack>

        {/* <Typography variant="body2" color="text.secondary">
          Size: {displaySize} | Type: PDF
        </Typography> */}

        {bodyText && (
          <Typography variant="body2" mt={1} sx={{ whiteSpace: 'pre-line' }}>
            {bodyText}
          </Typography>
        )}
      </Stack>
    );
  } catch (error) {
    return <div>File message not found</div>;
  }
};

export default MessageFile;